type Play = {
  fields: {
    name: string
    selected: number[]
  }[]
  isComplete: boolean
  isValid: boolean
}

type QuickPickConfig = {
  max: number
  min: number
  selectableMax: number
}

export const quickPickPlay = (
  { fields, isComplete, isValid }: Play,
  { max, min, selectableMax }: QuickPickConfig,
  fieldIndex: number,
  clearIfComplete = true,
) => {
  const numbers = new Set(fields[fieldIndex]?.selected)

  if (clearIfComplete) {
    const areAllFieldsComplete = fields.every(({ selected }) => selected.length === selectableMax)
    if (isComplete || (!isValid && areAllFieldsComplete)) numbers.clear()
  }

  return quickPickNumbers({ max, min, selectableMax }, numbers)
}

export const quickPickNumbers = (
  { max, min, selectableMax }: QuickPickConfig,
  numbers: Set<number> = new Set(),
) => {
  while (numbers.size < selectableMax) {
    numbers.add(getRandomNumber(min, max))
  }

  return [...numbers].sort((a, b) => a - b)
}
